/**
 * Network Information API Detector
 */

export interface NetworkResult {
  type?: string;
  effectiveType?: string;
  downlink?: number;
  rtt?: number;
}

interface NetworkInformation {
  type?: string;
  effectiveType?: string;
  downlink?: number;
  rtt?: number;
}

export async function detectNetworkInformation(): Promise<NetworkResult> {
  try {
    const connection = (navigator as Navigator & { connection?: NetworkInformation }).connection;

    if (!connection) {
      return {};
    }

    return {
      type: connection.type,
      effectiveType: connection.effectiveType,
      downlink: connection.downlink,
      rtt: connection.rtt,
    };
  } catch (error) {
    return {};
  }
}
